<template>
    <div class="json-editor-modal">
        <JsonEditorVue
            v-model="jsonData"
            :stringified="true"
            :readOnly="true"
            mode="text"
            class="json-editor mb-5"
        />
        <div class="flex justify-start gap-2">
            <CoreButton
                variant="tertiary"
                label="§ui_button.close"
                @click="modalStore.setClose"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import JsonEditorVue from 'json-editor-vue'
import CoreButton from '@/components/core/CoreButton.vue'
export default {
    name: 'JsonEditorModal',

    components: {
        JsonEditorVue,
        CoreButton,
    },

    data() {
        return {
            modalStore: useModalStore(),
            jsonData: 'somestring',
            loading: false,
        }
    },

    mounted() {
        this.jsonData = this.modalStore.data.jsonData
    },
}
</script>

<style scoped>
.json-editor-modal {
    .json-editor {
        & .jse-json-node.jse-root.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm.svelte-6mjnsm,
        .jse-main.svelte-ybuk0j {
            min-height: 500px;
        }
    }
}
</style>
